<template>
  <div styleName="toastWrapper">
    <div styleName="toastInner" :data-direction="style ? '' : position" :style="[style, computedWidth]">
      <div styleName="header" v-if="header">
        <svg width="31px" height="31px" viewBox="0 0 31 31" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="按钮切图" transform="translate(-177.000000, -519.000000)" fill-rule="nonzero">
              <g id="注意" transform="translate(177.000000, 519.000000)">
                <circle id="Oval-12" fill="#FFFFFF" cx="15.5" cy="15.5" r="10.5"></circle>
                <path d="M14,9 L17,9 L17,19 L14,19 L14,9 Z M14,20 L17,20 L17,23 L14,23 L14,20 Z" id="Combined-Shape" fill="#4A90E2"></path>
              </g>
            </g>
          </g>
        </svg>
        <span styleName="desc">{{headerDesc}}</span>
      </div>
      <div styleName="title" v-if="title">
        {{ title }}
      </div>
      <div styleName="toastText" :style="textStyle">
        {{ text }}
      </div>
      <div styleName="footer">
        <button @click="_confirm" v-if="buttonCount === 1">{{ btnText }}</button>
        <template v-else>
          <button @click="_confirm">{{ btnText }}</button>
          <button styleName="cancle" @click="_cancle">{{ btnCancelText }}</button>
        </template>
      </div>
      <div styleName="arrow" v-if="arrow">
        <svg width="19px" height="33px" viewBox="0 0 19 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="Dino加载" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Artboard-2" fill="#6CB6FD" fill-rule="nonzero">
              <path d="M9,0 L10,0 L19,8 L19,14 L12,7.77777778 L12,33 L7,33 L7,7.77777778 L0,14 L0,8 L9,0 Z" id="Combined-Shape"></path>
            </g>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
export default { 
  name: 'Toast',
  mixins: [CSSModules(styles)],
  data () {
    return {
      header: true,
      headerDesc: '注意',
      width: false,
      position: 'center',
      title: '',
      text: '',
      textStyle: null,
      buttonCount: 1,
      btnCancelText: '取消',
      arrow: false,
      btnOK: null,
      vm: null,
      btnText: '我知道了',
      btnCancel: null,
      triggerHide: true
    }
  },
  computed: {
    style () {
      if (this.position === 'center') {
        return null
      }
      if (typeof this.position === 'object') {
        if (this.arrow) {
          let { left, top } = this.position
          return {
            left,
            top: `${parseInt(top) + 38}px`
          }
        } else {
          return this.position
        }
      }
    },
    computedWidth () {
      if (this.width) {
        return {
          width: typeof width === 'number' ? `${this.width}px` : this.width
        }
      }
    }
  },
  methods: {
    _confirm (e) {
      this.btnOK && this.btnOK.call(this.vm, e)
      this.triggerHide && this.$toast.hide()
    },
    _cancle (e) {
      this.btnCancel && this.btnCancel.call(this.vm, e)
      this.triggerHide && this.$toast.hide()
    }
  },
  components: {
  }
}
</script>
